import Script from 'next/script'
import { IOttPageMeta } from '../../../utils'

const VideoObjectJsonLd = ({ assetMeta }: { assetMeta: IOttPageMeta }) => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BroadcastEvent',
    name: assetMeta.title,
    description: assetMeta.description,
    isLiveBroadcast: true,
    subtitleLanguage: 'עברית',
  }

  return (
    <Script
      id='VideoObjectJsonLdLiveBB'
      type='application/ld+json'
      strategy='beforeInteractive'
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(jsonLd),
      }}
    />
  )
}

export default VideoObjectJsonLd
